function isMap(value) {
    return value instanceof Map;
}

export { isMap };
